/* RESPONSIBLE TEAM: team-inbox */
import WorkspaceSettingsRoute from 'embercom/routes/apps/app/settings/base/workspace-settings-route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import { hash } from 'rsvp';

export default class MultilingualRoute extends WorkspaceSettingsRoute {
  @service declare appService: any;
  @service declare router: RouterService;
  @service declare store: any;
  @service declare session: Session;

  get app() {
    return this.appService.app;
  }

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);
    this.session.switchWorkspace(this.app.id);
    await this.session.workspace.fetchRequiredAttributes();
    await this.session.workspace.appSettingsLoader.promise;

    await super.beforeModel(transition);
    let app = this.modelFor('apps.app') as {
      canViewMultilingualGlossaryPage: boolean;
    };

    if (!app.canViewMultilingualGlossaryPage) {
      return this.router.transitionTo('apps.app.settings.workspace.general');
    }
    return;
  }

  async model() {
    try {
      return hash({
        generalSettings: this.store.findRecord('general-app-settings', this.appService.app?.id),
        messengerSettings: this.store.findRecord('messenger-settings/all', this.appService.app?.id),
      });
    } catch (e) {
      return {
        generalSettings: {},
        messengerSettings: {},
      };
    }
  }
}
